
import { regExpEscape } from './string';
/**
 * 根据字符串的正则对数组进行过滤，不要用includes，IE 11不兼容
 * @param data 要过滤的数组
 * @param str 根据str进行过滤
 * @param fitlerCb 回调，对数组内的item进行过滤，返回boolen
 */
export function filterByString(data: any[], str: string, filterCb: (item: any, regex: RegExp) => boolean) {
  const escapedValue = regExpEscape(str.trim());

  if (escapedValue === '') {
    return data;
  }

  const regex = new RegExp(escapedValue, 'i');
  const suggestions = data.filter((item: any) => filterCb(item, regex));
  return suggestions;
}
